import React from 'react'

const Manual_subir_giftcards_masivo = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Subir Gift Cards Manualmente (Masivo)
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Carga múltiples gift cards al sistema de manera masiva para agilizar tu gestión de recompensas.
        </p>
        <iframe
          src="https://scribehow.com/embed/Subir_Gift_Cards_Manualmente_Masivo__fTgTWmDgTx6wjGIsRjuzXw?as=scrollable"
          className="scribe-iframe-general-127"
          width="100%"
          height="3800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_subir_giftcards_masivo
